import * as flagsRound from '../atoms/icons/flagsround'
import * as flagsSquare from '../atoms/icons/flagssquare'

const icons = { ...flagsRound, ...flagsSquare }

export const IconFlagComponent = (icon) => {
	const component = Object.keys(icons)?.find((iconName) => iconName === icon) || null
	// eslint-disable-next-line import/namespace
	return component ? icons[component] : null
}
